import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "xwideOffset8": "letter-page-by-city-ab67c5c5-xwideOffset8-WXUgJq",
  "wideOffset10": "letter-page-by-city-ab67c5c5-wideOffset10-WXUgJq",
  "defaultOffset9": "letter-page-by-city-ab67c5c5-defaultOffset9-WXUgJq",
  "confined11": "letter-page-by-city-ab67c5c5-confined11-WXUgJq",
  "wideOffset1": "letter-page-by-city-ab67c5c5-wideOffset1-WXUgJq",
  "confinedOffset11": "letter-page-by-city-ab67c5c5-confinedOffset11-WXUgJq",
  "default9": "letter-page-by-city-ab67c5c5-default9-WXUgJq",
  "defaultOffset10": "letter-page-by-city-ab67c5c5-defaultOffset10-WXUgJq",
  "xwide12": "letter-page-by-city-ab67c5c5-xwide12-WXUgJq",
  "default6": "letter-page-by-city-ab67c5c5-default6-WXUgJq",
  "gridContainer": "letter-page-by-city-ab67c5c5-gridContainer-WXUgJq",
  "confined6": "letter-page-by-city-ab67c5c5-confined6-WXUgJq",
  "xwideOffset2": "letter-page-by-city-ab67c5c5-xwideOffset2-WXUgJq",
  "confinedOffset2": "letter-page-by-city-ab67c5c5-confinedOffset2-WXUgJq",
  "wideOffset7": "letter-page-by-city-ab67c5c5-wideOffset7-WXUgJq",
  "xwide0": "letter-page-by-city-ab67c5c5-xwide0-WXUgJq",
  "default11": "letter-page-by-city-ab67c5c5-default11-WXUgJq",
  "defaultOffset7": "letter-page-by-city-ab67c5c5-defaultOffset7-WXUgJq",
  "confinedOffset8": "letter-page-by-city-ab67c5c5-confinedOffset8-WXUgJq",
  "default8": "letter-page-by-city-ab67c5c5-default8-WXUgJq",
  "xwide10": "letter-page-by-city-ab67c5c5-xwide10-WXUgJq",
  "wideOffset0": "letter-page-by-city-ab67c5c5-wideOffset0-WXUgJq",
  "tiny2": "letter-page-by-city-ab67c5c5-tiny2-WXUgJq",
  "defaultOffset2": "letter-page-by-city-ab67c5c5-defaultOffset2-WXUgJq",
  "xwideOffset1": "letter-page-by-city-ab67c5c5-xwideOffset1-WXUgJq",
  "wide11": "letter-page-by-city-ab67c5c5-wide11-WXUgJq",
  "confined2": "letter-page-by-city-ab67c5c5-confined2-WXUgJq",
  "xwideOffset3": "letter-page-by-city-ab67c5c5-xwideOffset3-WXUgJq",
  "tiny1": "letter-page-by-city-ab67c5c5-tiny1-WXUgJq",
  "tiny9": "letter-page-by-city-ab67c5c5-tiny9-WXUgJq",
  "wideOffset6": "letter-page-by-city-ab67c5c5-wideOffset6-WXUgJq",
  "tiny4": "letter-page-by-city-ab67c5c5-tiny4-WXUgJq",
  "default4": "letter-page-by-city-ab67c5c5-default4-WXUgJq",
  "tiny5": "letter-page-by-city-ab67c5c5-tiny5-WXUgJq",
  "tiny7": "letter-page-by-city-ab67c5c5-tiny7-WXUgJq",
  "tinyOffset11": "letter-page-by-city-ab67c5c5-tinyOffset11-WXUgJq",
  "tiny12": "letter-page-by-city-ab67c5c5-tiny12-WXUgJq",
  "wide1": "letter-page-by-city-ab67c5c5-wide1-WXUgJq",
  "tinyOffset3": "letter-page-by-city-ab67c5c5-tinyOffset3-WXUgJq",
  "tinyOffset10": "letter-page-by-city-ab67c5c5-tinyOffset10-WXUgJq",
  "col": "letter-page-by-city-ab67c5c5-col-WXUgJq",
  "wide0": "letter-page-by-city-ab67c5c5-wide0-WXUgJq",
  "default5": "letter-page-by-city-ab67c5c5-default5-WXUgJq",
  "confinedOffset9": "letter-page-by-city-ab67c5c5-confinedOffset9-WXUgJq",
  "confinedOffset10": "letter-page-by-city-ab67c5c5-confinedOffset10-WXUgJq",
  "confinedOffset6": "letter-page-by-city-ab67c5c5-confinedOffset6-WXUgJq",
  "xwide4": "letter-page-by-city-ab67c5c5-xwide4-WXUgJq",
  "defaultOffset1": "letter-page-by-city-ab67c5c5-defaultOffset1-WXUgJq",
  "xwide1": "letter-page-by-city-ab67c5c5-xwide1-WXUgJq",
  "tiny0": "letter-page-by-city-ab67c5c5-tiny0-WXUgJq",
  "xwideOffset0": "letter-page-by-city-ab67c5c5-xwideOffset0-WXUgJq",
  "xwideOffset7": "letter-page-by-city-ab67c5c5-xwideOffset7-WXUgJq",
  "tiny6": "letter-page-by-city-ab67c5c5-tiny6-WXUgJq",
  "xwideOffset6": "letter-page-by-city-ab67c5c5-xwideOffset6-WXUgJq",
  "tinyOffset7": "letter-page-by-city-ab67c5c5-tinyOffset7-WXUgJq",
  "xwide5": "letter-page-by-city-ab67c5c5-xwide5-WXUgJq",
  "xwideOffset11": "letter-page-by-city-ab67c5c5-xwideOffset11-WXUgJq",
  "armstrongGridContainer": "letter-page-by-city-ab67c5c5-armstrongGridContainer-WXUgJq",
  "tinyOffset5": "letter-page-by-city-ab67c5c5-tinyOffset5-WXUgJq",
  "confinedOffset4": "letter-page-by-city-ab67c5c5-confinedOffset4-WXUgJq",
  "grid": "letter-page-by-city-ab67c5c5-grid-WXUgJq",
  "confined4": "letter-page-by-city-ab67c5c5-confined4-WXUgJq",
  "xwide3": "letter-page-by-city-ab67c5c5-xwide3-WXUgJq",
  "tinyOffset8": "letter-page-by-city-ab67c5c5-tinyOffset8-WXUgJq",
  "xwide7": "letter-page-by-city-ab67c5c5-xwide7-WXUgJq",
  "xwide9": "letter-page-by-city-ab67c5c5-xwide9-WXUgJq",
  "xwide8": "letter-page-by-city-ab67c5c5-xwide8-WXUgJq",
  "wide3": "letter-page-by-city-ab67c5c5-wide3-WXUgJq",
  "wideOffset8": "letter-page-by-city-ab67c5c5-wideOffset8-WXUgJq",
  "tiny8": "letter-page-by-city-ab67c5c5-tiny8-WXUgJq",
  "confinedOffset1": "letter-page-by-city-ab67c5c5-confinedOffset1-WXUgJq",
  "confined5": "letter-page-by-city-ab67c5c5-confined5-WXUgJq",
  "confinedOffset7": "letter-page-by-city-ab67c5c5-confinedOffset7-WXUgJq",
  "default1": "letter-page-by-city-ab67c5c5-default1-WXUgJq",
  "tiny3": "letter-page-by-city-ab67c5c5-tiny3-WXUgJq",
  "wideOffset2": "letter-page-by-city-ab67c5c5-wideOffset2-WXUgJq",
  "xwide11": "letter-page-by-city-ab67c5c5-xwide11-WXUgJq",
  "xwideOffset5": "letter-page-by-city-ab67c5c5-xwideOffset5-WXUgJq",
  "wideOffset4": "letter-page-by-city-ab67c5c5-wideOffset4-WXUgJq",
  "wideOffset11": "letter-page-by-city-ab67c5c5-wideOffset11-WXUgJq",
  "xwide2": "letter-page-by-city-ab67c5c5-xwide2-WXUgJq",
  "xwideOffset4": "letter-page-by-city-ab67c5c5-xwideOffset4-WXUgJq",
  "xwideOffset9": "letter-page-by-city-ab67c5c5-xwideOffset9-WXUgJq",
  "defaultOffset3": "letter-page-by-city-ab67c5c5-defaultOffset3-WXUgJq",
  "xwideOffset10": "letter-page-by-city-ab67c5c5-xwideOffset10-WXUgJq",
  "default2": "letter-page-by-city-ab67c5c5-default2-WXUgJq",
  "confined8": "letter-page-by-city-ab67c5c5-confined8-WXUgJq",
  "tiny10": "letter-page-by-city-ab67c5c5-tiny10-WXUgJq",
  "tinyOffset4": "letter-page-by-city-ab67c5c5-tinyOffset4-WXUgJq",
  "wide8": "letter-page-by-city-ab67c5c5-wide8-WXUgJq",
  "confinedOffset3": "letter-page-by-city-ab67c5c5-confinedOffset3-WXUgJq",
  "xwide6": "letter-page-by-city-ab67c5c5-xwide6-WXUgJq",
  "wide9": "letter-page-by-city-ab67c5c5-wide9-WXUgJq",
  "standardGridContainer": "letter-page-by-city-ab67c5c5-standardGridContainer-WXUgJq",
  "default0": "letter-page-by-city-ab67c5c5-default0-WXUgJq",
  "wide5": "letter-page-by-city-ab67c5c5-wide5-WXUgJq",
  "defaultOffset4": "letter-page-by-city-ab67c5c5-defaultOffset4-WXUgJq",
  "confined12": "letter-page-by-city-ab67c5c5-confined12-WXUgJq",
  "tiny11": "letter-page-by-city-ab67c5c5-tiny11-WXUgJq",
  "default12": "letter-page-by-city-ab67c5c5-default12-WXUgJq",
  "tinyOffset2": "letter-page-by-city-ab67c5c5-tinyOffset2-WXUgJq",
  "confined10": "letter-page-by-city-ab67c5c5-confined10-WXUgJq",
  "defaultOffset11": "letter-page-by-city-ab67c5c5-defaultOffset11-WXUgJq",
  "wideOffset9": "letter-page-by-city-ab67c5c5-wideOffset9-WXUgJq",
  "confined3": "letter-page-by-city-ab67c5c5-confined3-WXUgJq",
  "row": "letter-page-by-city-ab67c5c5-row-WXUgJq",
  "tinyOffset1": "letter-page-by-city-ab67c5c5-tinyOffset1-WXUgJq",
  "default10": "letter-page-by-city-ab67c5c5-default10-WXUgJq",
  "confined1": "letter-page-by-city-ab67c5c5-confined1-WXUgJq",
  "default7": "letter-page-by-city-ab67c5c5-default7-WXUgJq",
  "tinyOffset9": "letter-page-by-city-ab67c5c5-tinyOffset9-WXUgJq",
  "confined7": "letter-page-by-city-ab67c5c5-confined7-WXUgJq",
  "confined9": "letter-page-by-city-ab67c5c5-confined9-WXUgJq",
  "wide7": "letter-page-by-city-ab67c5c5-wide7-WXUgJq",
  "wide2": "letter-page-by-city-ab67c5c5-wide2-WXUgJq",
  "wideOffset3": "letter-page-by-city-ab67c5c5-wideOffset3-WXUgJq",
  "confined0": "letter-page-by-city-ab67c5c5-confined0-WXUgJq",
  "wide10": "letter-page-by-city-ab67c5c5-wide10-WXUgJq",
  "default3": "letter-page-by-city-ab67c5c5-default3-WXUgJq",
  "wide6": "letter-page-by-city-ab67c5c5-wide6-WXUgJq",
  "defaultOffset6": "letter-page-by-city-ab67c5c5-defaultOffset6-WXUgJq",
  "wideOffset5": "letter-page-by-city-ab67c5c5-wideOffset5-WXUgJq",
  "confinedOffset0": "letter-page-by-city-ab67c5c5-confinedOffset0-WXUgJq",
  "defaultOffset5": "letter-page-by-city-ab67c5c5-defaultOffset5-WXUgJq",
  "confinedOffset5": "letter-page-by-city-ab67c5c5-confinedOffset5-WXUgJq",
  "wide4": "letter-page-by-city-ab67c5c5-wide4-WXUgJq",
  "wideGridContainer": "letter-page-by-city-ab67c5c5-wideGridContainer-WXUgJq",
  "defaultOffset8": "letter-page-by-city-ab67c5c5-defaultOffset8-WXUgJq",
  "tinyOffset0": "letter-page-by-city-ab67c5c5-tinyOffset0-WXUgJq",
  "tinyOffset6": "letter-page-by-city-ab67c5c5-tinyOffset6-WXUgJq",
  "wide12": "letter-page-by-city-ab67c5c5-wide12-WXUgJq"
};